<template>
  <BarChart :chartData="chartData2" :options="options" />
</template>
<script>
import { Chart, registerables } from "chart.js";
import dayjs from "dayjs";
Chart.register(...registerables);
import { defineComponent } from "vue";
import { BarChart } from "vue-chart-3";
import tailwindSettings from "../../../tailwind.config";
import {Queue} from 'typescript-collections';

export default defineComponent({
  components: { BarChart },
  data: function () {
    return {
      days: 10,
    };
  },
  computed: {
    cards() {
      let cards = this.$store.state.user.cards;
      let now = dayjs();
      cards.forEach((card) => {
        let dueDate = dayjs(card.dueDate);
        card.daysLeft = dueDate.diff(now, "day");
        console.log("dl: " + card.daysLeft);
      });
      return cards;
    },
    options() {
      const options = {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
            },
          },
        },
      };
      return options;
    },
    chartData2() {
      let colors = tailwindSettings.theme.colors;
      let labels = [];
      let chartColors = [];
      let data = [];
      let dayLeftHashset = {};

      this.cards.forEach((card) => {
        let daysLeft = card.daysLeft;
        let counter = dayLeftHashset[daysLeft];
        if (counter == undefined) counter = 0;
        counter++;
        console.log("c: " + counter);
        dayLeftHashset[daysLeft] = counter;
      });

      console.log(JSON.stringify(dayLeftHashset) + "dlh");

      let colorQueue = new Queue();
      //colorQueue.enqueue(colors.palette1);
      //colorQueue.enqueue(colors.palette5);
      colorQueue.enqueue(colors.palette3);
      colorQueue.enqueue(colors.palette4);
      for (let i = 0; i < this.days; i++) {
        let count = dayLeftHashset[i];
        if(i == 0)
        {
          count = 0
          //for today it counts also days before
          const keys = Object.keys(dayLeftHashset).filter(x => x<=0)
          keys.forEach(key => {
            const add = dayLeftHashset[key]
            count+=add
          });
        }
        if (count == undefined) count = 0;
      
        let color = colorQueue.dequeue();
        chartColors.push(color);
        colorQueue.enqueue(color);
        data.push(count);
        let label = "today";
        if (i == 1) label = "tommorow";
        if (i > 1) label = `in ${i} days`;
        labels.push(label);
      }
      const chartData = {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: chartColors,
          },
        ],
      };
      return chartData;
    },
  },
  setup() {},
});
</script>
